import { render, staticRenderFns } from "./Frecuencia.vue?vue&type=template&id=7fa15a85&"
import script from "./Frecuencia.vue?vue&type=script&lang=js&"
export * from "./Frecuencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports